/**
 * @description: 新版首页快捷提单数据分离函数处理
 * @author: senlin.gu
 * @remark: 因为这些方法还是改变了引用，看看怎么设计成纯函数
 */
import {
  getMyProxyUsersAll,
  getProxyAuthAll,
  getSubmissionList,
  getUserAvailableFormsV2,
  getUserSubmissionHistory,
} from 'api/common-document';
import { getUserInfoNew } from 'api/base';
import commonQuickCreatorHandler from 'components/business/common/document-creator/index.handler';
import { customDepartmentName } from 'service/job';

export default {
  allAvailableFormList: [],

  businessTypeIconMap: {},

  businessTypeSvgNameMap: {
    SALARY_PAYMENT: 'business-type-payment-slip',
    REQUEST: 'business-type-application',
    EXPENSE: 'business-type-expense',
    AP_REQUEST: 'business-type-public-application',
    AP_PAYMENT: 'business-type-public-pay',
    CONTRACT: 'business-type-contract',
    BUDGET_JOURNAL: 'business-type-budget-journal',
    VENDOR: 'business-type-supplier-application',
    ACCRUAL: 'business-type-advanced-bill',
    OTHER: 'business-type-other',
    CUSTOM_ONE: 'business-typ-custom-one',
    CUSTOM_TWO: 'business-typ-custom-two',
    CUSTOM_THREE: 'business-typ-custom-three',
    CUSTOM_FOUR: 'business-typ-custom-four',
    CASH: 'business-cash',
  },

  setAllAvailableFormList(list) {
    this.allAvailableFormList = list;
  },

  getUserAvailableFormsByBusinessType(businessTypeId) {
    const { allAvailableFormList } = this;
    let list = [];
    allAvailableFormList.forEach((item) => {
      if (item.businessTypeId === businessTypeId) {
        list.push(item);
      }
    });
    return list;
  },

  createDocument({ applicant, document, job, jobId, copy, copyDetail, setNewApplyParam }) {
    commonQuickCreatorHandler.createDocument({ applicant, document, job, jobId, copy, copyDetail, setNewApplyParam });
  },

  joinJobText(data) {
    data = data || [];
    data.forEach((company) => {
      let { userJobsDTOList, companyName } = company;
      company.name = companyName;
      userJobsDTOList.forEach((item) => {
        let { position, rank, duty, tenantDefault } = item,
          tempArr = [];
        if (duty) {
          tempArr.push(window.$t('global-1.key171', { arg1: duty, cm: '职务: {arg1}' }));
        }
        if (rank) {
          tempArr.push(window.$t('global-1.key172', { arg1: rank, cm: '级别: {arg1}' }));
        }
        item.mainText = `${position}`;
        if (tenantDefault) {
          item.mainText = item.mainText + window.$t('global-1.key173', { cm: '（主岗）' });
        }
        item.extraText = customDepartmentName(item.departmentName, item.departmentPath) || '';
      });
      company.list = userJobsDTOList;
    });
    return data;
  },

  getDefaultJob(jobsList) {
    let selectedJob = null;
    let defaultJob = null;
    let mainJob = null;
    for (let i = 0; i < jobsList.length; i++) {
      let userJobsDTOList = jobsList[i].userJobsDTOList;
      if (!defaultJob) {
        defaultJob = userJobsDTOList.find((job) => job.docDefault);
      }
      if (!mainJob) {
        mainJob = userJobsDTOList.find((job) => job.tenantDefault);
      }
    }
    selectedJob = defaultJob;
    if (!selectedJob) {
      selectedJob = mainJob;
    }
    if (!selectedJob) {
      let job = this.getIsSingleJob(jobsList);
      if (job) {
        selectedJob = job;
      }
    }
    return selectedJob;
  },

  getIsSingleJob(jobsList) {
    let job = null;
    if (jobsList.length === 1) {
      let single = jobsList[0];
      let userJobsDTOList = single.userJobsDTOList;
      if (userJobsDTOList.length === 1) {
        job = userJobsDTOList[0];
      }
    }
    return job;
  },

  processAvailableForms(formList) {
    let list = [];
    let businessTypeMap = {};
    let businessTypeList = [];
    formList.forEach((form) => {
      if (!businessTypeMap[form.businessTypeId]) {
        list.push(form.businessTypeId);
        businessTypeMap[form.businessTypeId] = {
          businessTypeId: form.businessTypeId,
          businessTypeName: form.businessTypeName,
          svgIcon: this.getBusinessTypeSvgIconName(form.businessTypeId),
          documentList: [form],
        };
      } else {
        businessTypeMap[form.businessTypeId].documentList.push(form);
      }
    });
    list.forEach((item) => {
      businessTypeList.push(businessTypeMap[item]);
    });
    return businessTypeList;
  },

  setBusinessTypeIconMap(submissionList) {
    let businessTypeIconMap = {};
    if (submissionList.length > 0) {
      submissionList.forEach((submission) => {
        submission.businessTypes &&
          submission.businessTypes.forEach((businessType) => {
            businessTypeIconMap[businessType.id] = {
              color: businessType.color || getComputedStyle(document.body).getPropertyValue('--theme-main'),
              svgIconName: this.businessTypeSvgNameMap[businessType.icon],
            };
          });
      });
    }
    this.businessTypeIconMap = businessTypeIconMap;
  },

  getBusinessTypeSvgIconName(businessTypeId) {
    return this.businessTypeIconMap[businessTypeId];
  },

  processThirdParty(allApplicationList) {
    let thirdPartyAppList = [];
    if (allApplicationList && allApplicationList.length > 0) {
      let thirdParty = allApplicationList.find((item) => item.sectionCode === 'THIRD_PARTY');
      if (thirdParty && thirdParty.sectionDetail) {
        thirdParty.sectionDetail.forEach((item) => {
          thirdPartyAppList.push({
            type: 'THIRD_PARTY',
            formName: item.appName,
            link: item.link,
          });
        });
      }
    }
    return thirdPartyAppList;
  },

  getFilteredBusinessTypeList(formList, sourceBusinessTypeList) {
    let tempList = [];
    let destBusinessTypeList = [];
    formList.forEach((item) => {
      if (tempList.indexOf(item.businessTypeId) === -1) tempList.push(item.businessTypeId);
    });
    sourceBusinessTypeList.forEach((item) => {
      if (tempList.indexOf(item.id) > -1) {
        destBusinessTypeList.push(item);
      }
    });
    return destBusinessTypeList;
  },

  analyzeHistory(source, submissionId) {
    let historyList = [];
    if (source.length > 0) {
      source.forEach((submission) => {
        if (submissionId == submission.id) {
          let businessTypes = submission.businessTypes;
          if (businessTypes.length > 0) {
            businessTypes.forEach((businessType) => {
              let formHistoryDTOS = businessType.formHistoryDTOS;
              if (formHistoryDTOS.length > 0) {
                historyList.push(...formHistoryDTOS);
              }
            });
          }
        }
      });
    }
    return historyList;
  },

  cacheResultData: null,
  cacheProxyInfo: null,

  getProxyUserInfoApi(resolve) {
    if (this.cacheProxyInfo) {
      resolve(this.cacheProxyInfo);
      return;
    }
    let hasProxyFlag = false;
    let proxyUserList = [];
    let proxyInfo = null;
    getProxyAuthAll().then(
      (res) => {
        if (res.status === 200 && res.data) {
          getMyProxyUsersAll().then(
            (res) => {
              if (res.status === 200 && res.data) {
                hasProxyFlag = true;
                proxyUserList = res.data;
                proxyInfo = { hasProxyFlag, proxyUserList };
                this.cacheProxyInfo = proxyInfo;
                resolve(proxyInfo);
              }
            },
            () => {
              resolve({ hasProxyFlag, proxyUserList });
            }
          );
        } else {
          proxyInfo = { hasProxyFlag, proxyUserList };
          this.cacheProxyInfo = proxyInfo;
          resolve(proxyInfo);
        }
      },
      () => {
        resolve({ hasProxyFlag, proxyUserList });
      }
    );
  },

  /**
   * @description: 新版首页快捷提数据处理
   * @author: senlin.gu
   * @remark:
   *  三种场景：
   *  1. 只有一个快捷提单大类，不显示大类页面
   *  2. 只有一个或者多个业务类型
   *  3. 有代理提单
   *  设置页面路径: http://uat.huilianyi.com/main/setting/business-scenarios-management
   */
  getInitData(myInfo, thirdPartyAppList, init) {
    let type = 'submission';
    if (init && this.cacheResultData) {
      return new Promise((resolve) => {
        resolve(this.cacheResultData);
      });
    }
    return new Promise((resolve, reject) => {
      Promise.all([
        getSubmissionList(),
        getUserInfoNew(myInfo.userOID),
        //getUserSubmissionHistory(myInfo.userOID)
      ]).then(
        (res) => {
          if (res[0].data && res[1].data && res[1].data) {
            let submissionList = [];
            let applicant = res[1].data;
            //let historyList = this.analyzeHistory(res[2].data);
            let historyList = this.analyzeHistory([]);
            let businessTypeList = [];
            res[0].data.forEach((item, index) => {
              if (
                (item.businessTypes && item.businessTypes.length > 0) ||
                (thirdPartyAppList && thirdPartyAppList.length)
              ) {
                item.sequence = index;
                submissionList.push(item);
              }
            });
            let companyWithUserJobsDTOList = applicant.companyWithUserJobsDTOList;
            let jobList = this.joinJobText(companyWithUserJobsDTOList);
            let defaultJob = this.getDefaultJob(companyWithUserJobsDTOList);
            let defaultSubmission = null;

            let singleJob = this.getIsSingleJob(jobList);
            let isSingleJobFlag = false;
            if (singleJob) {
              isSingleJobFlag = true;
            }

            //this.setBusinessTypeIconMap(submissionList);
            let singleSubmission = submissionList.length === 1;
            if (singleSubmission) {
              defaultSubmission = submissionList[0];
              businessTypeList = defaultSubmission.businessTypes;

              Promise.all([
                getUserAvailableFormsV2(myInfo.userOID, defaultSubmission.id, null, defaultJob.jobId),
                getUserSubmissionHistory(myInfo.userOID, defaultSubmission.id, defaultJob.jobId),
              ]).then((res1) => {
                if (res1[0].data && res1[1].data) {
                  this.allAvailableFormList = res1[0].data;
                  let destBusinessTypeList = this.getFilteredBusinessTypeList(res1[0].data, businessTypeList);
                  let historyList1 = this.analyzeHistory(res1[1].data, defaultSubmission.id);
                  let resultData = {
                    type,
                    applicant,
                    submissionList,
                    jobList,
                    businessTypeList: destBusinessTypeList,
                    defaultSubmission,
                    defaultJob,
                    isSingleJobFlag,
                    historyList: historyList1,
                    availableFormList: res[0].data,
                  };
                  if (init) {
                    this.cacheResultData = resultData;
                  }
                  resolve(resultData);
                } else {
                  reject();
                }
              });

              /*getUserAvailableFormsV2(myInfo.userOID, defaultSubmission.id, null, defaultJob.jobId).then(
                (res) => {
                  if (res.status === 200 && res.data) {
                    this.allAvailableFormList = res.data;
                    let destBusinessTypeList = this.getFilteredBusinessTypeList(res.data, businessTypeList);
                    resolve({
                      type,
                      applicant,
                      submissionList,
                      jobList,
                      businessTypeList: destBusinessTypeList,
                      defaultSubmission,
                      defaultJob,
                      isSingleJobFlag,
                      historyList,
                      availableFormList: res.data,
                    });
                  } else {
                    reject();
                  }
                },
                (err) => {
                  reject();
                }
              );*/
              return;
            }
            let resData = {
              type,
              applicant,
              submissionList,
              jobList,
              businessTypeList,
              defaultSubmission,
              defaultJob,
              historyList,
              isSingleJobFlag,
            };
            if (init) {
              this.cacheResultData = resData;
            }
            resolve(resData);
          }
        },
        (err) => {}
      );
    });
  },
};
